import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Authenticated instance — attaches Bearer token from localStorage
export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("repurpose_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

// Public instance — NEVER attaches auth. Use for verify-email, forgot-password, reset-password, login, register.
export const publicApi = axios.create({ baseURL: API });

export const PLATFORM_META = {
    instagram: { label: "Instagram", color: "#E1306C" },
    tiktok: { label: "TikTok", color: "#25F4EE" },
    linkedin: { label: "LinkedIn", color: "#0A66C2" },
    shorts: { label: "Shorts / Reels", color: "#FF0050" },
    newsletter: { label: "Email Newsletter", color: "#FACC15" },
};
